var map = {
	"./aichi.png": "ca75",
	"./akita.png": "f052",
	"./aomori.png": "3a05",
	"./chiba.png": "76da",
	"./ehime.png": "63cf",
	"./fukui.png": "0987",
	"./fukuoka.png": "1278",
	"./fukushima.png": "fd06",
	"./gifu.png": "b12a",
	"./gunma.png": "de01",
	"./hiroshima.png": "9511",
	"./hokkaido.png": "ee83",
	"./hyogo.png": "a8bb",
	"./ibaraki.png": "a4ba",
	"./ishikawa.png": "0b30",
	"./iwate.png": "4f44",
	"./kagawa.png": "65a6",
	"./kagoshima.png": "c112",
	"./kanagawa.png": "220a",
	"./kochi.png": "9353",
	"./kumamoto.png": "4ee0",
	"./kyoto.png": "fbf3",
	"./matsuri_roulette_anime.gif": "0ce9",
	"./mie.png": "87cb",
	"./miyagi.png": "b332",
	"./miyazaki.png": "9b59",
	"./nagano.png": "646c",
	"./nagasaki.png": "69b3",
	"./nara.png": "8c3d",
	"./niigata.png": "6c03",
	"./oita.png": "dcaa",
	"./okayama.png": "1fa2",
	"./okinawa.png": "0130",
	"./osaka.png": "883f",
	"./saga.png": "3228",
	"./saitama.png": "aa2d",
	"./shiga.png": "ec74",
	"./shimane.png": "a6ef",
	"./shizuoka.png": "a2e3",
	"./tochigi.png": "48a5",
	"./tokushima.png": "aae5",
	"./tokyo.png": "9db5",
	"./tottori.png": "26a0",
	"./toyama.png": "ed00",
	"./wakayama.png": "a07a",
	"./yamagata.png": "240d",
	"./yamaguchi.png": "7e63",
	"./yamanashi.png": "6e25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "561d";